f<template>
    <div class="color-chooser" >
        <div class="color-modal" >
            <div class="img">
                <h4>{{ selectedColorLabel }}</h4>
                <img :src="selected_image" />
            </div>
            <div class="colors">
                <div v-for="color in colorsMen" :class="{ active: color.name == selectedColor.name }" v-if="gender === 'M'" @click="selectColor(color)">
                    <div :class="'color ' + color.name"></div>
                </div>
                <div v-for="color in colorsWomen" :class="'color ' + color.name + (color.name === selectedColor.name ? ' active' : '')"  v-if="gender === 'W'" @click="selectColor(color)">
                </div>
            </div>
            <div class="desc" v-if="lang=='fr'">
                <h2>Nuancier <span v-if="gender=='M'">Homme</span><span v-if="gender=='W'">femme</span></h2>
                <p>
                Vous disposez ici d'une large gamme de teintes.
                </p>

                <p>
                Malgré tout les soins que nous accordons aux

                teintures de nos cuirs, nous ne pouvons vous

                garantir leur exactitude.
                </p>

                <p>
                Les peaux sont un matériau vivant, qui leur

                donne leur âme, leur noblesse, et qui rend

                chacun des gants d’Amélie unique.
                </p>

                <p class="alt">
                Cliquez sur votre choix, puis sur le bouton

                "valider" ci-dessous.
                </p>

                <button class="focus" @click="validateColor">Valider</button>
            </div>

            <div class="desc" v-if="lang=='en'">
                <h2><span v-if="gender=='M'">MEN</span><span v-if="gender=='W'">WOMEN</span> color chart</h2>
                <p>
                    You have here a wide range of colors.
                </p>
                <p>
                    Despite all the care we give to our leather dyes,

                    we can not guarantee its accuracy.
                </p>
                <p>
                    The skins are a living material, which gives

                    them their soul, their nobility, and that makes

                    each Amelie's gloves so unique.
                </p>
                <p>
                    Click on your choice, then click "Submit" below.
                </p>

                <button class="focus" @click="validateColor">Submit</button>
            </div>

        </div>
    </div>
</template>

<script>

  export default {
    name: 'Color-chooser',
    data() {
      const allColors = [
        { name: 'argent', fr: 'argent', en: 'silver', scope: 'MW' },
        { name: 'gris_perle', fr: 'gris perle', en: 'pearl grey', scope: 'MW' },
        { name: 'flanelle', fr: 'flanelle', en: 'dark grey', scope: 'MW' },
        { name: 'canard', fr: 'canard', en: 'duck', scope: 'MW' },
        { name: 'clematite', fr: 'clématite', en: 'clematis', scope: 'MW' },
        { name: 'gitane', fr: 'gitane', en: 'gipsy', scope: 'MW' },
        { name: 'bleu_marine', fr: 'bleu marine', en: 'navy blue', scope: 'MW' },
        { name: 'anis', fr: 'anis', en: 'anise', scope: 'W' },
        { name: 'emeraude', fr: 'emeraude', en: 'emerald green', scope: 'MW' },
        { name: 'perrier', fr: 'perrier', en: 'perrier', scope: 'MW' },
        { name: 'laurier', fr: 'laurier', en: 'dark olive green', scope: 'MW' },
        { name: 'tilleul', fr: 'tilleul', en: 'gray asparagus', scope: 'MW' },
        { name: 'rose_indien', fr: 'rose indien', en: 'indian pink', scope: 'W' },
        { name: 'ocre', fr: 'ocre', en: 'ochre', scope: 'MW' },
        { name: 'brique', fr: 'brique', en: 'brick red', scope: 'MW' },
        { name: 'new_brique', fr: 'new brique', en: 'new brick', scope: 'MW' },
        { name: 'corrida', fr: 'corrida', en: 'corrida', scope: 'MW' },
        { name: 'chanel', fr: 'chanel', en: 'chanel', scope: 'MW' },
        { name: 'camel', fr: 'camel', en: 'camel', scope: 'MW' },
        { name: 'poil_chameau', fr: 'poil de chameau', en: 'caramel', scope: 'MW' },
        { name: 'betterave', fr: 'betterave', en: 'beet', scope: 'MW' },
        { name: 'marron_fonce', fr: 'marron foncé', en: 'dark brown', scope: 'MW' },
        { name: 'noir', fr: 'noir', en: 'black', scope: 'MW' },
      ];

      let selectedColor = allColors[allColors.length - 1];
      if (this.color) {
        selectedColor = allColors.filter(col => col.name === this.color)[0];
      }

      return {
        allColors,
        selectedColor,
      };
    },
    props: ['lang', 'gender', 'color'],
    methods: {
      selectColor(color) {
        this.selectedColor = color;
      },
      validateColor() {
        this.$emit('color_selected', { color: this.selectedColor.name, fr: this.selectedColor.fr, en: this.selectedColor.en });
      },
    },
    computed: {
      colorsMen() {
        return this.allColors.filter(item => item.scope.indexOf('M') !== -1);
      },
      colorsWomen() {
        return this.allColors.filter(item => item.scope.indexOf('W') !== -1);
      },
      selected_image() {
        return require(`../assets/colors/women/glove_${this.selectedColor.name}.png`);
      },
      selectedColorLabel() {
        return this.lang === 'fr' ? this.selectedColor.fr : this.selectedColor.en;
      },
    },
  };
</script>


<style lang="scss">
    .color-chooser {

        max-width: 900px;

        .color-modal {
            display: flex;
            background: url('../assets/order_bg.png') no-repeat center;
            background-size: cover;
            margin:auto;

            @media screen and (max-width:768px){
                flex-direction: column;
                padding:2rem 1rem 5rem 1rem;
            }
            @media screen and (min-width:768px){
                padding:3rem;

            }

        }

        .img {
            flex: 320px;
            flex-shrink: 0;
            margin-top:0;
            text-align: center;
        }
        .colors {
            flex: 160px 0;
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;
            @media screen and (max-width:768px){
                flex-direction: row;
            }
            height: 500px;
            margin-right: 0.5rem;

            .active {
                .color {
                    border:3px #9c554b solid;
                }
            }

            .color {
                float:left;
                &:hover {
                    transition: border-color 1s ease-in;
                    cursor: pointer;
                    border-color:#9c554b;
                }
            }
        }

        .desc {
            color:white;
            flex: 300px;

            h2 {
                text-shadow: 1px 1px #333;
                color:white;
                font-weight: bold;
                text-transform: uppercase;
            }

            .alt {
                color: #9c554b;
            }
        }

    }

</style>



// WEBPACK FOOTER //
// src/components/ColorChooser.vue